import React, { useState } from "react";
import { useRegisterNewsLetterMutation } from "../../api/newsLetterApi";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import './Newslatter2.css';
const SubmitHandler = (e) => {
  e.preventDefault();
};

const Newslatter2 = (props) => {
  const [sendEmail] = useRegisterNewsLetterMutation();
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  const handleSendClick = async () => {
    const model = {
      email: email,
    };

    await sendEmail(model).then((response) => {
      if (response.data.isSuccess) {
        toast.success(response.data.messages[0]);
        setEmail("");
      } else {
        toast.error("Ooops something went wrong!");
      }
    });
  };

  return (
    <section className="wpo-subscribe-section-s2 section-padding">
      <div className="container-fluid">
        <div className="wpo-subscribe-wrap">
          <div className="subscribe-content">
            <div className="newsletter-icon">
              <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="38" fill="url(#newsletterGradient)" opacity="0.2"/>
                <path d="M20 30L40 45L60 30M20 30V55C20 56.6569 21.3431 58 23 58H57C58.6569 58 60 56.6569 60 55V30M20 30L37 22C38.8856 20.9333 41.1144 20.9333 43 22L60 30" 
                  stroke="url(#iconGradient)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                <defs>
                  <linearGradient id="newsletterGradient" x1="2" y1="2" x2="78" y2="78" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#ff8a00"/>
                    <stop offset="1" stopColor="#8a2be2"/>
                  </linearGradient>
                  <linearGradient id="iconGradient" x1="20" y1="22" x2="60" y2="58" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#ff8a00"/>
                    <stop offset="0.5" stopColor="#b794f6"/>
                    <stop offset="1" stopColor="#8a2be2"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="subscribe-text">
              <h3>{t("Subscribe to our newsletter to receive latest news on our services")}</h3>
              <p>En güncel kurslar, indirimler ve eğitim haberleri için abone olun!</p>
            </div>
          </div>
          <div className="subscribe-form">
            <form onSubmit={SubmitHandler}>
              <div className="input-field">
                <div className="input-wrapper">
                  <svg className="input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8L10.89 13.26C11.5 13.67 12.5 13.67 13.11 13.26L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <input type="email" value={email} placeholder={t("Enter your email")} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <button type="submit" onClick={handleSendClick}>
                  <svg className="button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>{t("Subscribe")}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newslatter2;
